<template>
    <ClientOnly>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 187 181"
            fill="none"
            v-bind="$attrs"
            width="187"
            height="181">
            <g opacity="0.58">
                <g :filter="`url(#filter0_i_1071_15603_${timestamp})`">
                    <path
                        d="M82.8885 8.07009C86.2131 -2.24472 100.787 -2.24472 104.111 8.07009L118.499 52.7089C119.985 57.32 124.272 60.445 129.111 60.445H175.828C186.612 60.445 191.115 74.2479 182.411 80.6228L144.488 108.399C140.606 111.242 138.982 116.257 140.459 120.84L154.914 165.688C158.234 175.988 146.444 184.52 137.72 178.13L100.083 150.564C96.1626 147.693 90.8374 147.693 86.9172 150.564L49.2804 178.13C40.5563 184.52 28.7662 175.988 32.0861 165.688L46.5412 120.84C48.0184 116.257 46.3945 111.242 42.5125 108.399L4.5891 80.6228C-4.11479 74.2479 0.388264 60.445 11.1719 60.445H57.8894C62.7281 60.445 67.0146 57.32 68.5008 52.7089L82.8885 8.07009Z"
                        :fill="`url(#paint0_linear_1071_15603_${timestamp})`" />
                </g>
                <path
                    d="M83.3644 8.22347C86.5401 -1.62918 100.46 -1.62918 103.636 8.22347L118.023 52.8622C119.576 57.6796 124.054 60.945 129.111 60.945H175.828C186.127 60.945 190.431 74.1292 182.115 80.2194L144.192 107.995C140.136 110.966 138.44 116.206 139.983 120.994L154.438 165.842C157.61 175.683 146.346 183.828 138.015 177.727L100.378 150.161C96.2822 147.161 90.7178 147.161 86.6217 150.161L48.985 177.727C40.6539 183.828 29.39 175.683 32.562 165.842L47.0171 120.994C48.5603 116.206 46.8639 110.966 42.808 107.995L4.88454 80.2194C-3.43063 74.1292 0.873203 60.945 11.1719 60.945H57.8894C62.9455 60.945 67.424 57.6796 68.9767 52.8623L83.3644 8.22347Z"
                    stroke="white" />
            </g>
            <defs>
                <filter
                    :id="`filter0_i_1071_15603_${timestamp}`"
                    x="0"
                    y="0.333984"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                    width="187"
                    height="180">
                    <feFlood
                        flood-opacity="0"
                        result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="9" />
                    <feComposite
                        in2="hardAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend
                        mode="normal"
                        in2="shape"
                        :result="`effect1_innerShadow_1071_15603_${timestamp}`" />
                </filter>
                <linearGradient
                    :id="`paint0_linear_1071_15603_${timestamp}`"
                    x1="93.5"
                    y1="0.333984"
                    x2="93.5"
                    y2="180.334"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="white" />
                    <stop
                        offset="1"
                        stop-color="white"
                        stop-opacity="0" />
                </linearGradient>
            </defs>
        </svg>
    </ClientOnly>
</template>

<script setup lang="ts">
const timestamp = Date.now() + getRandomNumber(1, 500)
</script>
